module.exports = __webpack_public_path__ + "img/1.3.2dca7e74.png";